import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { ERROR_REPORTING_CONFIG } from '@ep/shared';
import { SessionFreezeService } from '../services/session-freeze.service';

const ALLOWED_WHILE_FROZEN = ['/v2/errorreporting/report'];

@Injectable({
  providedIn: 'root',
})
export class FrozenSessionInterceptor implements HttpInterceptor {
  private readonly sessionFreezeService = inject(SessionFreezeService);
  private readonly errorReportingConfig = inject(ERROR_REPORTING_CONFIG, { optional: true });

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.sessionFreezeService.isFrozen || this.isAllowedWhileFrozen(request.url)) {
      return next.handle(request);
    }

    return EMPTY;
  }

  private isAllowedWhileFrozen(url: string): boolean {
    const reportEndpoint = this.errorReportingConfig?.reportEndpoint;
    const allowed = reportEndpoint ? [...ALLOWED_WHILE_FROZEN, reportEndpoint] : ALLOWED_WHILE_FROZEN;

    return allowed.some((path) => url.includes(path));
  }
}
